<section *ngIf="certificateDetails" class="certificate pt-5 pb-5 lightblue-bg2">
    <div class="bigContainer container">
        <div class="row">
            <div class="col-12 mb-4 col-md me-4">
                <div class="light-bg div-shadow text-center certificate__block d-flex align-items-center justify-content-center"
                    style="background-repeat: no-repeat; background-position: center center; background-size: cover;">
                    <img style="width: 100%;" src="{{certificateDetails?.certificateInfo?.certificateImageUrl}}"
                        alt="certificate">
                </div>
            </div>
            <div class="certificate__profile mb-4 col-12">
                <div
                    class="p-5 light-bg div-shadow text-center certificate__block d-flex align-items-center justify-content-center">
                    <div>
                        <div class="certificate__icon mb-3">
                            <i class="icon-certificate"></i>
                        </div>
                        <h3 class="heading24 font-mob-18 lh-30 montserrat-semibold mb-5" style="word-break: break-all;">
                            {{certificateDetails.name}}</h3>
                        <a *ngIf="!sessionOut" href="{{certificateDetails?.certificateInfo?.certificatePdfUrl}}" target="_blank" download
                            class="btn btn-primary btn-block mb-3" (click)="downloadCertificateClicked()"><span>Download
                                Certificate as PDF</span></a>
                        <a  *ngIf="!sessionOut"
                                class="btn btn-primary btn-block mb-3 mx-2" (click)="downloadImage(certificateDetails?.base64Url)" downloadCertificateClicked><span >Download
                                    Certificate as Image</span></a>
                        <a *ngIf="!sessionOut" href="javascript:void(0)" (click)="copy()"
                            class="btn btn-outline-primary btn-block mb-3"><span>Copy
                                Link</span></a>
                        <a style="display: inline-block;" class="mb-5" *ngIf="user?.email===certificateDetails?.email"
                            href="https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME" rel="nofollow"
                            (click)="addToLinkedIn()" target="_blank">
                            <img src="https://download.linkedin.com/desktop/add2profile/buttons/en_US.png "
                                alt="LinkedIn Add to Profile button">
                        </a>
                        <p  *ngIf="!sessionOut" class="textPara pd-t10 mb-2">Share your joy!</p>
                        <ul  *ngIf="!sessionOut" class="list-unstyled font-30 d-flex align-items-center justify-content-center">
                            <li (click)="share('fb')" class="p-2"><a href="javascript:void(0)"><img width="40"
                                        src="assets/images/fb-share-icon.png" alt="Facebook share"></a></li>
                            <li (click)="share('twitter')" class="p-2"><a href="javascript:void(0)"><img width="40"
                                        src="assets/images/twitter-share-icon.png" alt="Twitter share"></a></li>
                            <li class="p-2 linkedin-share"><a href="javascript:void(0)"><img width="40"
                                        src="assets/images/linkedin-share-icon.png" alt="Linkedin share"></a>
                                <ul>
                                    <li (click)="share('linkedin')">Share Certificate Link</li>
                                    <li (click)="openLinkedin()">Post Certificate with Images</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <p *ngIf="user?.email===certificateDetails?.email" class="py-3 text-center">
                    <strong class="montserrat-medium navColor">Something wrong? </strong>
                    <a (click)="openModal()" class="regular-link" href="javascript:void(0)">Tell us.</a>
                </p>
            </div>
        </div>
    </div>
</section>

<section *ngIf="pathwayDetails" class="certificate pt-5 pb-5 lightblue-bg2">
    <div class="bigContainer container">
        <div class="row">
            <div class="col-12 mb-4 col-md me-4">
                <div class="light-bg div-shadow text-center certificate__block d-flex align-items-center justify-content-center"
                    style="background-repeat: no-repeat; background-position: center center; background-size: cover;">
                    <img style="width: 100%;" src="{{pathwayDetails?.certificateImageUrl}}" alt="certificate">
                </div>
            </div>
            <div class="certificate__profile mb-4 col-12">
                <div
                    class="p-5 light-bg div-shadow text-center certificate__block d-flex align-items-center justify-content-center">
                    <div>
                        <div class="certificate__icon mb-3">
                            <i class="icon-certificate"></i>
                        </div>
                        <h3 class="heading24 font-mob-18 lh-30 montserrat-semibold mb-5" style="word-break: break-all;">
                            {{user.firstName}}</h3>
                        <a  *ngIf="!sessionOut" href="{{pathwayDetails?.certificatePdfUrl}}" target="_blank" download
                            class="btn btn-primary btn-block mb-3" (click)="downloadCertificateClicked()"><span >Download
                                Certificate as PDF</span></a>
                        <a  *ngIf="!sessionOut" href="{{pathwayDetails?.certificateImageUrl}}" target="_blank" download
                            class="btn btn-primary btn-block mb-3 mx-2" (click)="downloadCertificateClicked()"><span >Download
                                Certificate as Image</span></a>
                        <a  *ngIf="!sessionOut" href="javascript:void(0)" (click)="copy()"
                            class="btn btn-outline-primary btn-block mb-3"><span>Copy
                                Link</span></a>
                        <a style="display: inline-block;" class="mb-5" *ngIf="user?.email===pathwayDetails?.email"
                            href="https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME" rel="nofollow"
                            (click)="addToLinkedIn()" target="_blank">
                            <img src="https://download.linkedin.com/desktop/add2profile/buttons/en_US.png "
                                alt="LinkedIn Add to Profile button">
                        </a>
                        <p  *ngIf="!sessionOut" class="textPara pd-t10 mb-2">Share your joy!</p>
                        <ul  *ngIf="!sessionOut" class="list-unstyled font-30 d-flex align-items-center justify-content-center">
                            <li (click)="share('fb')" class="p-2"><a href="javascript:void(0)"><img width="40"
                                        src="assets/images/fb-share-icon.png" alt="Facebook share"></a></li>
                            <li (click)="share('twitter')" class="p-2"><a href="javascript:void(0)"><img width="40"
                                        src="assets/images/twitter-share-icon.png" alt="Twitter share"></a></li>
                            <li (click)="share('linkedin')" class="p-2"><a href="javascript:void(0)"><img width="40"
                                        src="assets/images/linkedin-share-icon.png" alt="Linkedin share"></a>
                                <ul>
                                    <li>Share Certificate URL</li>
                                    <li (click)="openLinkedin()">Share with multiple image</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <p *ngIf="user?.email===pathwayDetails?.email" class="py-3 text-center">
                    <strong class="montserrat-medium navColor">Something wrong? </strong>
                    <a (click)="openModal()" class="regular-link" href="javascript:void(0)">Tell us.</a>
                </p>
            </div>
        </div>
    </div>
</section>

<div *ngIf="(!this.pathwayName && !certificateDetails) || (this.pathwayName && !pathwayDetails)" class="pageloader">
</div>